"use client";

import Image from "next/image";
import { Button } from "../ui/button";
import { MoveUpRight } from "lucide-react";
import Link from "next/link";
import { motion, useScroll, useSpring, useTransform } from "motion/react";
import { useIsMobile } from "@/hooks/use-mobile";
import { usePathname } from "next/navigation";

export default function Header() {
  const pathname = usePathname();
  const isMobile = useIsMobile();
  const { scrollY } = useScroll();
  const springSize = useSpring(scrollY, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  const size = useTransform(springSize, [0, 800], ["100%", "0%"]);
  const y = useTransform(springSize, [0, 150], ["100%", "0%"]);

  return (
    <header className="sticky top-0 left-0 right-0 z-50 max-w-screen-2xl mx-auto w-full w-max-[1312px] flex items-center justify-between px-2 md:px-8 py-4 md:flex-row flex-col-reverse gap-4 md:gap-0">
      <motion.div
        className="flex-1"
        style={{
          y: isMobile ? y : 0,
          maxWidth: isMobile ? "auto" : size,
          opacity: isMobile ? y : size,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <Link href="/" title="Home">
          <Image
            src="/images/sal-red.png"
            alt="Logo"
            width={131}
            height={48}
            style={{
              minHeight: "48px",
              minWidth: "131px",
            }}
          />
        </Link>
      </motion.div>

      <div className="flex-1 flex justify-center md:w-auto w-full">
        <ul
          className="flex items-center backdrop-blur-3xl rounded-full py-2 px-2 w-full justify-between"
          style={{
            backgroundColor: "#ded2c491",
          }}
        >
          <li>
            <Button
              variant={pathname === "/" ? "secondary" : "linkSecondary"}
              asChild
              className="px-2 md:px-4"
            >
              <Link href="/" title="Home">
                Home
              </Link>
            </Button>
          </li>
          <li>
            <Button
              variant={
                pathname === "/who-we-are" ? "secondary" : "linkSecondary"
              }
              asChild
              className="px-2 md:px-4"
            >
              <Link href="/who-we-are" title="Who we are">
                Who we are
              </Link>
            </Button>
          </li>
          <li>
            <Button
              variant={
                pathname.startsWith("/categories") ? "secondary" : "linkSecondary"
              }
              asChild
              className="px-2 md:px-4"
            >
              <Link href="/categories" title="Categories">
                Products
              </Link>
            </Button>
          </li>
          <li>
            <Button
              variant={
                pathname === "/contact-us" ? "secondary" : "linkSecondary"
              }
              asChild
              className="px-2 md:px-4"
            >
              <Link href="/contact-us" title="Contact us">
                Contact us
              </Link>
            </Button>
          </li>
        </ul>
      </div>

      <div className="flex-1 justify-end hidden md:flex">
        <Button size="lg" variant="secondary" asChild>
          <Link href="/contact-us" title="Request a quote">
            Request a quote
            <MoveUpRight className="size-4" />
          </Link>
        </Button>
      </div>
    </header>
  );
}
